import { Header } from "../header/Header";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorPage } from "./ErrorPage";
import { Footer } from "./Footer";
import { enableScroll } from "../../../helpers/miscHelper";

export const Container = ({
	className = "",
	showFooter = true,
	absolute = false,
	noPadding = false,
	children,
}) => {
	useEffect(() => {
		enableScroll(document);
	}, []);
	return (
		<ErrorBoundary FallbackComponent={ErrorPage}>
			<div className={`${className} min-w-[300px]`}>
				<Header />

				<div
					className={`pt-14 lg:pt-20 pb-0 flex flex-col w-full h-screen overflow-y-auto ${
						noPadding ? "px-0" : "px-2 lg:px-6"
					}`}
				>
					<div className={`flex flex-col flex-grow w-full `}>
						{children}
					</div>
					{showFooter && <Footer />}
				</div>
			</div>
		</ErrorBoundary>
	);
};
